import { useEffect, useState } from 'react'
import { NavLink, Outlet, useParams } from 'react-router-dom'
import { getAgent } from '@/lib/api'
import type { Agent } from '@/types'
import { StatusDot } from '@/components/ui/StatusDot'

const TABS = [
  { path: 'overview', label: 'Overview' },
  { path: 'identity', label: 'Identity' },
  { path: 'prompt', label: 'Prompt' },
  { path: 'tools', label: 'Tools' },
  { path: 'skills', label: 'Skills' },
  { path: 'schedules', label: 'Schedules' },
  { path: 'performance', label: 'Performance' },
  { path: 'gateways', label: 'Gateways' },
]

export function AgentDetailLayout() {
  const { id } = useParams<{ id: string }>()
  const [agent, setAgent] = useState<Agent | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) return
    setLoading(true)
    getAgent(id).then((data) => {
      setAgent(data)
      setLoading(false)
    })
  }, [id])

  if (loading) return <div style={{ color: 'var(--text-secondary)' }}>Cargando…</div>
  if (!agent) return <div style={{ color: 'var(--status-error)' }}>Agente no encontrado.</div>

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
        <h1 style={{ fontSize: 20, fontWeight: 500 }}>{agent.name}</h1>
        <StatusDot status={agent.status} />
      </div>
      <div className="mono" style={{ fontSize: 12, marginBottom: 20 }}>{agent.id}</div>

      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid var(--border)', marginBottom: 20 }}>
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            style={({ isActive }) => ({
              padding: '8px 14px',
              fontSize: 13,
              color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
              borderBottom: isActive ? '2px solid var(--status-hitl)' : '2px solid transparent',
              marginBottom: -1,
            })}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet context={{ agent }} />
    </div>
  )
}
